import React, { useEffect, useState } from 'react';

import { useParams } from 'react-router-dom';
import { addGroupBySubscription } from './SubscriptionService';

import { getAllGroupsByMembershipId } from '../Groups/GroupService';

import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import OutlinedInput from '@mui/material/OutlinedInput';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import { notify } from 'utils/notify';
import { extractErrorMessage } from 'utils/extractErrorMessage';
// import appProgrammeList from './AppProgrammeList'
//import listSubscriptionGroups from './SubscriptionGroupList';

const AttachGroup = ({ listSubscriptionGroups }) => {
  const [open, setOpen] = useState(false);
  const [groups, setGroups] = useState<any[]>([]);

  const [selectedGroupId, setSelectedGroupId] = useState(null); // State to hold the selected user ID
  //const { accountid } = useParams();
  const { membershipid } = useParams();
  const { subscriptionid } = useParams();

  const handleChange = (prodid) => {
    setSelectedGroupId(prodid); // Update the selected user ID when the user is changed
  };

  const handleClickOpen = () => {
    listGroups();
    setOpen(true);
  };

  const handleClose = (event, reason) => {
    if (reason !== 'backdropClick') {
      setOpen(false);
    }
  };

  useEffect(() => {
    // listUsersByGroup();
    listGroups();
  }, []);

  function listGroups() {
    getAllGroupsByMembershipId(membershipid)
      .then((response) => {
        setGroups(response.data);
      })
      .catch((error) => {
        console.error(error);
        notify(extractErrorMessage(error));
      });
  }

  function attachSelectedGroup(groupid, subscriptionid) {
    addGroupBySubscription(subscriptionid, groupid)
      .then(() => {
        // appProgrammeList();
        listSubscriptionGroups();
        handleClose(null, null);
      })
      .catch((error) => {
        console.error(error);
        notify(extractErrorMessage(error));
      });
  }

  return (
    <div>
      <Button onClick={handleClickOpen}>Select Group</Button>
      <Dialog disableEscapeKeyDown open={open}>
        <DialogTitle>Select</DialogTitle>
        <DialogContent>
          <Box component="form" sx={{ display: 'flex', flexWrap: 'wrap' }}>
            <FormControl sx={{ m: 1, minWidth: 120 }}>
              {/* <InputLabel htmlFor="demo-dialog-native">Name</InputLabel> */}
              <Select
                native
                value={selectedGroupId || ''} // Use selectedAppId as the value
                onChange={(e) => handleChange(e.target.value)}
                input={
                  <OutlinedInput label="Select User" id="demo-dialog-native" />
                }
              >
                {/* Ensure "Select Item" option is selected by default */}
                <option value={''} disabled>
                  Select Group
                </option>
                {/* Map over items to generate options */}
                {groups.map((item) => (
                  <option key={item.id} value={item.id}>
                    {item.groupName}
                  </option>
                ))}
              </Select>
            </FormControl>
          </Box>
        </DialogContent>
        <DialogActions>
          {/* <Button onClick={handleClose}>Cancel</Button>
          <Button onClick={addProgrammeAssignment(progid, selectedProgrammeId)}>Add</Button> */}
          <Button onClick={() => handleClose(null, null)}>Cancel</Button>
          <Button
            onClick={() => attachSelectedGroup(selectedGroupId, subscriptionid)}
          >
            Add
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default AttachGroup;
